<template>
  <div>
    <div class="title">
      <h3>
        {{$t('dashboard.subscription_status')}}
      </h3>
    </div>
    <div class="plan">
      <div class="highlight">
        <div class="spike"></div>
        <h2 class="period_amount">
          <template v-if="$auth.user().membership_active">
            ✔
          </template>
          <template v-else>
            ✘
          </template>
        </h2>
      </div>
      <div class="details">
        <template v-if="$auth.user().membership_active">
          <div class="left">
          </div>
          <div class="right">
            <h5 class="access_type">
              {{$t(`subscription.access_type.total_access`)}} <!-- Al final no existe el acceso parcial -->
            </h5>
            <p class="total_amount">
              {{$t('dashboard.membership_status.expires_at', {membership_expires_at: $d(new
              Date($auth.user().membership_expires_at), 'short')})}}
            </p>
          </div>
        </template>
        <template v-else>
          <a href="#" @click="membershipHandler">
            <div class="right">
              <h5 class="duration_type">
                {{$t('dashboard.membership_status.no_membership')}}
              </h5>
              <p class="total_amount">
                {{$t('dashboard.membership_status.view_subscription_plans')}}
              </p>
            </div>
          </a>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MembershipStatus',
  methods:{
    membershipHandler(){
      this.$router.push({name: 'subscribe'});
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../styles/variables';
@import '../styles/classes';

.title{
  h3{
    background-color: $pallete_main_color;
    color: #ffffff;
    font-weight: bolder;
    text-transform: uppercase;
    font-size: 1.5em;
    margin: 0 0 1em 0;
    padding: 5px 1em;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
  }
}

.plan{
  @extend %plan-block;
  margin-bottom: 2em;
  width: 100%;
  max-width: unset;

  .details{
    background-color: $pallete_clear_color;
    color: $pallete_dark_text_color;
  }
}

</style>